import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { Path, PathGenerator, ExternalPath } from "../../constants/path";
import { settings } from "../../assets/settings";
import { Link, Button } from "../util/Clickable";
import { Image } from "../util/Image";
import { EXTERNAL_API } from "../../constants/endpoints";

import ReactGA from 'react-ga';
ReactGA.initialize('UA-142451086-2');
ReactGA.pageview(window.location.pathname + window.location.search);

declare var UIkit;

class Plan extends Component {

  render = () => {
    const plan = this.props.plan;
    console.log("プランだよ");
    console.log(plan);

    if(plan == null){
      return null;
    }
    return (
      <div className="uk-plan-base">
        <h5 className="uk-margin-xsmall">
          { plan.Plan && plan.Plan.replace(/&amp;/g, "&") }
        </h5>
        <div className="uk-margin-xsmall">
          <small>{ plan.Room }</small>
        </div>
        <div className="uk-margin-xsmall uk-grid-small uk-flex-bottom" data-uk-grid>
          <div className="uk-width-expand">
            <div className="uk-plan-price-base">
              <span className="">
                価格:
              </span>
              <span className="uk-plan-price uk-h3">
                { String(plan.Price).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') }
              </span>
              <span>
                円 ~
              </span>
            </div>
          </div>
          <div className="uk-width-auto">
            <ReactGA.OutboundLink className=" uk-button uk-button-clear uk-button-small" eventLabel={"詳細 > " + plan.Hotel + " /  " + plan.Plan + " /  " + plan.Room + " > 詳細・予約  > " + plan.Get} to={plan.Get} target="_blank">
                詳細・予約
              </ReactGA.OutboundLink>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
    }, dispatch)
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Plan))
